export const MINOR_CUPS: ITarotCard[] = [
  {
    id: 36,
    rank: "1",
    numeral: "I",
    name: "Ace of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/ace_of_cups.svg",
    wordpressId: "2335",
  },
  {
    id: 37,
    rank: "2",
    numeral: "II",
    name: "Two of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/two_of_cups.svg",
    wordpressId: "2342",
  },
  {
    id: 38,
    rank: "3",
    numeral: "III",
    name: "Three of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/three_of_cups.svg",
    wordpressId: "2347",
  },
  {
    id: 39,
    rank: "4",
    numeral: "IV",
    name: "Four of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/four_of_cups.svg",
    wordpressId: "2379",
  },
  {
    id: 40,
    rank: "5",
    numeral: "V",
    name: "Five of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/five_of_cups.svg",
    wordpressId: "2384",
  },
  {
    id: 41,
    rank: "6",
    numeral: "VI",
    name: "Six of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/six_of_cups.svg",
    wordpressId: "2389",
  },
  {
    id: 42,
    rank: "7",
    numeral: "VII",
    name: "Seven of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/seven_of_cups.svg",
    wordpressId: "2394",
  },
  {
    id: 43,
    rank: "8",
    numeral: "VIII",
    name: "Eight of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/eight_of_cups.svg",
    wordpressId: "2401",
  },
  {
    id: 44,
    rank: "9",
    numeral: "IX",
    name: "Nine of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/nine_of_cups.svg",
    wordpressId: "2406",
  },
  {
    id: 45,
    rank: "10",
    numeral: "X",
    name: "Ten of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/ten_of_cups.svg",
    wordpressId: "2412",
  },
  {
    id: 46,
    rank: "11",
    numeral: "XI",
    name: "Page of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/page_of_cups.svg",
    wordpressId: "2417",
  },
  {
    id: 47,
    rank: "12",
    numeral: "XII",
    name: "Knight of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/knight_of_cups.svg",
    wordpressId: "2428",
  },
  {
    id: 48,
    rank: "13",
    numeral: "XIII",
    name: "Queen of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/queen_of_cups.svg",
    wordpressId: "2433",
  },
  {
    id: 49,
    rank: "14",
    numeral: "XIV",
    name: "King of Cups",
    arcana: "cups",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/cups/king_of_cups.svg",
    wordpressId: "2438",
  },
];
